import {
  throttle
} from "../helpers";

const initScroller = function (scrollEl) {
  const updateScrollerStatus = function (scrollWrapper, scroller) {
    const scrollMax = scroller.scrollWidth - scroller.clientWidth;
    if (scroller.scrollLeft > 10) {
      scrollWrapper.classList.add('scroller--start');
    } else {
      scrollWrapper.classList.remove('scroller--start');
    }

    if (scroller.scrollLeft < scrollMax) {
      scrollWrapper.classList.add('scroller--end');
    } else {
      scrollWrapper.classList.remove('scroller--end');
    }
  }

  if (scrollEl) {
    const scroller = scrollEl.querySelector('.scroller__inner');
    scroller.addEventListener('scroll', throttle(() => updateScrollerStatus(scrollEl, scroller), 200)); // Onscroll
    updateScrollerStatus(scrollEl, scroller); // Onload
  }
}

if (document.readyState != 'loading') {
  [].forEach.call(
    document.querySelectorAll('.scroller'),
    el => initScroller(el)
  );
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(
      document.querySelectorAll('.scroller'),
      el => initScroller(el)
    );
  });
}
